import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { Link, Menu as UikitMenu } from 'vvs-uikit'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { isBlindMode } from 'utils'
import styled from 'styled-components'
import { Path } from 'config/constants/paths'

import { footerLinks } from './config/footerConfig'
import VvsGotchiLogo from './VvsGotchiMenu/GotchiLogo'
import getVvsGotchiMenuConfig from './VvsGotchiMenu/config'
import VvsGotchiRightSideMenuContent from './VvsGotchiMenu/RightSideMenuContent'
import { getActiveMenuItemStartsWithOrHome } from './utils'

const VvsGotchiMenu = ({ children }) => {
  const { isDark, toggleTheme } = useTheme()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useLocation()

  const menuConfig = useMemo(() => getVvsGotchiMenuConfig(t), [t])
  const activeMenuItem = getActiveMenuItemStartsWithOrHome({ menuConfig, pathname })

  return (
    <UikitMenu
      rightHandSideMenu={<VvsGotchiRightSideMenuContent />}
      isGamified
      homeIcon={
        <HomeLink style={{ flexBasis: 150 }} href={Path.VVS_GOTCHI}>
          <VvsGotchiLogo />
        </HomeLink>
      }
      isDark={isDark}
      isBlindMode={isBlindMode()}
      toggleTheme={toggleTheme}
      t={t}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      links={menuConfig}
      subLinks={[]}
      footerLinks={footerLinks(t)}
      activeItem={activeMenuItem?.href}
      buyVvsLabel=""
    >
      {children}
    </UikitMenu>
  )
}

export default VvsGotchiMenu

const HomeLink = styled(Link)`
  flex-basis: 72px;
  flex-shrink: 0;
`
